import { createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6039e117"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "burger" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle", {'active': _ctx.active}]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.realClick && _ctx.realClick(...args))),
    tabindex: "0",
    onKeypress: [
      _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.passClick && _ctx.passClick(...args)), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.passClick && _ctx.passClick(...args)), ["prevent"]), ["space"]))
    ]
  }, _hoisted_2, 34))
}